/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { getMenuParentElements, menuHasChildren } from "../../menuHelpers";

const DesktopMainMenu = (props) => {
  const { sitemegamenu, activeMenu, setActiveMenu, sitemegamenumuotolevy } =
    props;
  const parentMenu = getMenuParentElements(
    sitemegamenu.concat(sitemegamenumuotolevy), // NOTE: concat megamenu and muotolevy-menu
  );
  if (!parentMenu) return null;
  return (
    <ul className="megamenu__main menu">
      {parentMenu.map((item) => {
        const hasChildren = menuHasChildren(
          sitemegamenu.concat(sitemegamenumuotolevy), // NOTE: concat megamenu and muotolevy-menu
          item.ID,
        );
        if (!hasChildren) {
          return (
            <li>
              <a href={item.url}>{item.title}</a>
            </li>
          );
        }
        return (
          <li>
            <a
              role="button"
              onClick={(e) => {
                e.preventDefault();
                if (activeMenu && activeMenu.ID === item.ID) {
                  setActiveMenu(null);
                } else {
                  setActiveMenu(item);
                }
              }}
            >
              {item.title}
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default DesktopMainMenu;
